<template>
  <div>
    <div v-if="value.company"><strong>{{value.company}} ({{value.contactName}} {{value.contactLastname}})</strong> </div>
    <div v-else><strong>{{value.contactName}} {{value.contactLastname}}</strong></div>
    <div>ph: {{value.phoneNumber}}</div>
    <div v-if="value.address2">{{value.address2}}</div>
    <div>{{value.address}}</div>
    <div>{{value.city}}, {{value.state}}, {{value.postCode}}</div>
    <div>{{value.country}}</div>
  </div>
</template>

<script>
export default {
  name: 'ViewShippingDetails',
  props: {
    value: {
      contactName: String,
      contactLastname: String,
      company: String,
      address: String,
      address2: String,
      city: String,
      country: String,
      state: String,
      postCode: String,
      phoneNumber: String
    }
  }
}
</script>

<style scoped>

</style>
